module.exports = __webpack_public_path__ + "media/de_de_s2_Knut.b80dac5b.oga";